import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BaseModalComponent } from "./base-modal.component";

@NgModule({
  declarations: [BaseModalComponent],
  imports: [CommonModule, NgbModule],
  exports: [BaseModalComponent],
})
export class BaseModalModule {}
